import { Flex } from '@chakra-ui/react';

const Licenses = () => <Flex>Licenses</Flex>;

export default Licenses;
